import { render, staticRenderFns } from "./TheNote.vue?vue&type=template&id=75dfcb6a&scoped=true&"
import script from "./TheNote.vue?vue&type=script&lang=js&"
export * from "./TheNote.vue?vue&type=script&lang=js&"
import style0 from "./TheNote.vue?vue&type=style&index=0&id=75dfcb6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75dfcb6a",
  null
  
)

export default component.exports